<template>
  <div class="container">
    <div class="card filter-section" :class="{ 'filter-collapsed': !filterVisible }">
      <div class="card-body">
        <div class="row">
          <div v-if="!filterVisible" class="filter-toggle-icon" @click="toggleFilter">
            <i class="fa fa-search"></i>
          </div>
          <div v-else>
            <div class="row">
              <div class="col-md-3">
                <label for="from-date">From</label>
                <div class="input-group">
                  <Datepicker1 class="datepicker-here form-control digits" :format="format" v-model="settlementStore.filters.fromDate" :enable-time-picker="false" data-language="en" placeholder="Select date" />
                </div>
              </div>
              <div class="col-md-3">
                <label for="to-date">To</label>
                <div class="input-group">
                  <Datepicker1 class="datepicker-here form-control digits" :format="format" v-model="settlementStore.filters.toDate" :enable-time-picker="false" data-language="en" placeholder="Select date" />
                </div>
              </div>
              <div class="col-md-3">
                <label for="reference">Settlement reference</label>
                <div class="input-group">
                  <input type="text" id="reference" class="form-control text-input" placeholder="0123456" v-model="settlementStore.filters.reference" />
                </div>
              </div>
              <div class="col-md-2">
                <label>&nbsp;</label>
                <div class="input-group">
                  <button class="btn btn-green" @click="search">Search</button>
                </div>
              </div>
              <div class="col-md-1 text-end">
                <label>&nbsp;</label>
                <button class="btn form-control" @click="toggleFilter"><i class="fa fa-chevron-up"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="table-responsive signal-table" v-if="hasResults">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">Time</th>
              <th scope="col">Reference</th>
              <th scope="col">Face value</th>
              <th scope="col">We pay you</th>
              <th scope="col">Payment status</th>
              <th scope="col">Payment method</th>
              <th scope="col">Info</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(settlements, date) in groupedSettlements" :key="date">
              <tr>
                <td colspan="8"><strong>{{ format(new Date(date)) }}</strong></td> 
              </tr>
              <tr v-for="(settlement, index) in settlements" :key="index">
                <td>{{ formatTime(settlement.created_at) }}</td>
                <td>{{ settlement.settlement_ref }}</td>
                <td>{{ formatCurrency(settlement.face_value) }}</td>
                <td>{{ formatCurrency(settlement.total_amount) }}</td>
                <td :class="{'text-green': settlement.payment_status === 'Settled', 'text-secondary': settlement.payment_status === 'Pending'}">
                  {{ settlement.payment_status }}
                </td>
                <td>{{ settlement.payment_method }}</td>
                <td @click="showModal(settlement, index)">
                  <i class="fa fa-arrow-right info-icon"></i>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="pagination-wrapper">
          <div class="pagination-container">
            <button @click="changePage(1)" :disabled="settlementStore.currentPage === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(settlementStore.currentPage - 1)" :disabled="settlementStore.currentPage === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
            <span>Page <input type="number" v-model.number="settlementStore.currentPage" @change="changePage(settlementStore.currentPage)" /> of {{ totalPages }}</span>
            <button @click="changePage(settlementStore.currentPage + 1)" :disabled="settlementStore.currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
            <button @click="changePage(totalPages)" :disabled="settlementStore.currentPage === totalPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
          </div>
          <div class="pagination-summary">
            Displaying settlements {{ startSettlement }} – {{ endSettlement }} of {{ totalEntries }}
          </div>
        </div>
      </div>
      <div v-else class="no-results">No results found.</div>
    </div>

    <div class="modal fade" id="detailsModal" tabindex="-1" aria-labelledby="detailsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-slideout modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <button :disabled="!hasPrevItem" class="btn" @click="showPrev">
              <i class="fa fa-arrow-left"></i>
            </button>
            <button :disabled="!hasNextItem" class="btn" @click="showNext">
              <i class="fa fa-arrow-right"></i>
            </button>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- 顯示交易詳細資訊 -->
            <div>
              <p class="detail-line">
                <span>Date:</span>
                <span class="f-w-500">{{ formattedDate }}</span>
              </p>
              <p class="detail-line">
                <span>Time:</span>
                <span class="f-w-500">{{ formattedTime }}</span>
              </p>
              <hr>
              <p class="detail-line">
                <span>Payment status:</span>
                <strong :class="{'text-green': selectedItem.payment_status === 'Settled', 'text-secondary': selectedItem.payment_status === 'Pending'}">
                  {{ selectedItem.payment_status }}
                </strong>
              </p>
              <p class="detail-line">
                <span>Settlement Reference:</span>
                <span class="f-w-500">{{ selectedItem.settlement_ref }}</span>
              </p>
              <p class=" d-flex justify-content-end">
                <span class="view-trans" @click="viewTransactions">View transactions</span>
              </p>
            </div>
            <hr>
            <!-- 顯示金額和其他財務資訊 -->
            <div class="detail-total">
              <p class="detail-line">
                <span>Face value:</span>
                <span class="f-w-500">{{ formatCurrency(selectedItem.face_value) }}</span>
              </p>
              <p class="detail-line">
                <span>Commission:</span>
                <span class="f-w-500">{{ formatCurrency(selectedItem.commission) }}</span>
              </p>
              <p class="detail-line">
                <span>Fees & bond:</span>
                <span class="f-w-500">{{ formatCurrency(selectedItem.deposit) }}</span>
              </p>
              <p class="detail-line">
                <span>Refunds:</span>
                <span class="f-w-500">{{ formatCurrency(selectedItem.refunds) }}</span>
              </p>
              <hr>
              <p class="detail-line">
                <strong>Total amount:</strong>
                <strong class="f-w-700 f-24">{{ formatCurrency(selectedItem.total_amount) }}</strong>
              </p>
            </div>
            <!-- 下載結算報告按鈕 -->
            <div class="mt-5">
              <button class="btn detail-download" @click="handEmailAndPrint(selectedItem.id)">Download settlement report<i class="fa fa-download"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useSettlementStore } from '@/store/driver/settlement';
import { useTransactionStore } from '@/store/driver/transaction';
import { useRouter, onBeforeRouteLeave } from 'vue-router';
import { useCashPaymentStore } from '@/store/admin/cashPayment/cashpayment';
import { Modal } from 'bootstrap';
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

const settlementStore = useSettlementStore();
const transactionStore = useTransactionStore();
const cashPaymentStore = useCashPaymentStore();
const router = useRouter();

const filterVisible = ref(false);
const selectedItem = ref({});
const currentIndex = ref(0);
const formattedDate = ref('');
const formattedTime = ref('');
let bsModal = null;

const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

// 格式化貨幣函數
const formatCurrency = (value) => {
  const absValue = Math.abs(value);
  return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

const toggleFilter = () => {
  filterVisible.value = !filterVisible.value;
};

const search = async () => {
  settlementStore.currentPage = 1;
  await settlementStore.fetchSettlements();
};

const changePage = async (page) => {
  if (page < 1 || page > totalPages.value) return;
  settlementStore.currentPage = page;
  await settlementStore.fetchSettlements(page,10);
};

onMounted(async () => {
  changePage(1);
  await settlementStore.fetchSettlements();
  
 // 初始化模態視窗，只在 element 存在時初始化
 const modalElement = document.getElementById('detailsModal');
  if (modalElement) {
    bsModal = new Modal(modalElement, {
      backdrop: true,
      keyboard: true
    });
  }
});

// 將日期時間拆分並格式化，只顯示時間部分
const formatTime = (datetime) => {
  const date = new Date(datetime);
  return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
};

// 將資料根據日期進行分組
const groupedSettlements = computed(() => {
  if (!settlementStore.settlements || settlementStore.settlements.length === 0) {
    return {};
  }
  
  return settlementStore.settlements.reduce((acc, settlement) => {
    if (!settlement || !settlement.created_at) return acc;
    
    const date = settlement.created_at.split(' ')[0]; // 取得日期部分
    if (!acc[date]) acc[date] = [];
    acc[date].push(settlement);
    return acc;
  }, {});
});

const showModal = (item, index) => {
  selectedItem.value = { ...item };
  currentIndex.value = index;

  const [date, time] = item.created_at.split(' ');
  formattedDate.value = format(new Date(date)); // 使用格式化日期
  formattedTime.value = formatTime(item.created_at); // 使用完整的日期時間來格式化時間

  bsModal.show();
};

const viewTransactions = async () => {
  bsModal.hide();

  transactionStore.filters.reference = selectedItem.value.settlement_ref;
  transactionStore.shouldResetFilters = false;

  await router.push({ path: '/transaction' });
};

const flatSettlements = computed(() => {
  return settlementStore.settlements;
});

const hasPrevItem = computed(() => currentIndex.value > 0);
const hasNextItem = computed(() => currentIndex.value < flatSettlements.value.length - 1);

const showPrev = () => {
  if (hasPrevItem.value) {
    currentIndex.value--;
    showModal(flatSettlements.value[currentIndex.value], currentIndex.value);
  }
};

const showNext = () => {
  if (hasNextItem.value) {
    currentIndex.value++;
    showModal(flatSettlements.value[currentIndex.value], currentIndex.value);
  }
};

const handEmailAndPrint = async (id)=>{
    await cashPaymentStore.printPayments(id); // 獲取付款信息
    bsModal.hide();

  };

const hasResults = computed(() => settlementStore.totalEntries > 0);
const totalPages = computed(() => settlementStore.totalPages);
const totalEntries = computed(() => settlementStore.totalEntries);
const startSettlement = computed(() => (settlementStore.currentPage - 1) * settlementStore.itemsPerPage + 1);
const endSettlement = computed(() => Math.min(settlementStore.currentPage * settlementStore.itemsPerPage, totalEntries.value));

// 使用 onBeforeRouteLeave 鉤子來清空篩選條件
onBeforeRouteLeave(() => {
  // 清空篩選條件
  settlementStore.filters.fromDate = '';
  settlementStore.filters.toDate = '';
  settlementStore.filters.reference = '';

  transactionStore.shouldResetFilters = true;
  settlementStore.currentPage = 1;
});


</script>

<style scoped>
.container {
    position: relative;
    min-height: 100vh;
}

.view-trans{
  cursor: pointer;
  font-size: 16px;
  color: #8476f4;
  border-bottom: 1px solid #8476f4;
}

.filter-section {
    margin-bottom: 20px;
    border-radius: 8px;
    border: 1px solid #e5e5e5;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.filter-collapsed .card-body {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.filter-toggle-icon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 24px;
    color: #666;
    cursor: pointer;
}

span,strong {
  font-size: 18px;
}

.table-responsive {
    padding: 20px;
}

.signal-table .table-hover tbody tr:hover {
    background-color: #f5f5f5;
}

thead th {
    position: sticky;
    top: 0;
    background: #fff;
}

.info-icon {
    font-size: 20px;
    padding: 10px;
    border-radius: 20%;
    cursor: pointer;
    color: #8476f4;
}

.info-icon:hover {
    background-color: #8476f4;
    color: white;
}

.pagination-wrapper {
    display: flex;
    justify-content: space-between;
    padding: 20px;
}

.pagination-container {
    display: flex;
    align-items: center;
}

.pagination-container button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 16px;
    color: #8476f4;
}

.pagination-container span {
    margin: 0 10px;
}

.pagination-container input {
    width: 50px;
    text-align: center;
}

.pagination-summary {
    margin-top: 5px;
    font-size: 14px;
}

.modal-dialog-slideout {
    max-width: 485px;
    width: 60%;
    margin: 0;
    height: 100%;
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    transition: transform 0.3s ease-out;
}

.modal-content {
    height: 100%;
    border-radius: 0;
    padding-right: 20px;
    padding-left: 20px;
}

.modal-header {
    display: flex;
    justify-content: flex-end;
}

.modal-body {
    overflow-y: auto;
    flex-grow: 1;
}

.detail-line {
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
}

.detail-total {
    margin-top: 50px;
}

.detail-download {
    width: 100%;
    border: 2px inset #d9dde3;
    padding: 10px;
    font-size: 18px;
}

.detail-download i {
    font-size: 24px;
    margin-left: 100px;
}

.no-results {
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
}

.text-green{
    color: #04c962;
}

@media (max-width: 1366px) {
    .modal-dialog-slideout {
        max-width: 100vw;
        width: 100%;
        margin: 0;
        height: 100vh;
        position: fixed;
        right: 0;
        top: 0;
        bottom: 0;
        transition: none;
        border-radius: 0;
    }

    .modal-content {
        height: 100%;
        border-radius: 0;
    }
}
</style>
